<app-header></app-header>

<div class="character-port-container">
  <div id="map" style="width: 100%; height: 100%;">
    <div class="character-scroll">
      @if (!invitationdetail) {
        <div class="character-card">No invitation details found.</div>
      }
      @for (item of invitationdetail; track item) {
        <div class="character-card">
          <div class="game-profile">
            <div class="image-container">
              <img [src]="item.image?imageurl+item.image:'assets/images/no_images.png'" class="profile-img" />
            </div>
          </div>
          <form [formGroup]="invitationForm" >
            <div class="card-content-m">
              <div class="game-name">
                <h4>{{item.gamename}}</h4>
              </div>
              <ul>
                <li><span>Character Name:</span>
                @if (characterNames && characterNames?.length > 0) {
                  <ng-container class="character-dropdown">
                    <ng-select class="wt-select" formControlName="charOption" (change)="onOptionChange($event)" [items]="characterNames"
                      bindLabel="nickname" placeholder="Choose…" [clearable]="false" appendTo="body">
                      <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                    </ng-select>
                  </ng-container>
                }
                <input type="text" [(ngModel)]="culture" disabled  [ngModelOptions]="{standalone: true}" placeholder="Enter Culture" style="width: 100%;" />
                @if (!characterNames || characterNames?.length === 0) {
                  <button type="button" class="plus-primary mx-2"
                    routerLink="/player-detail/create"><i class="fa fa-plus fa-lg"></i></button>
                  }
                </li>
                <span class="text-danger f-size mb-2">{{characternullerror}}</span>
                <li><span>Level:</span> {{ item.level }}</li>
              </ul>
              *Mark Birth location on map canvas
            </div>
            <div class="action-buttons">
              <button class=" accept-button" [disabled]="invitationForm.invalid" (click)="save(item,'ACCEPTED')" type="submit"
              >Accept</button>
              <button class="reject-button" (click)="save(item,'REJECTED')">Reject</button>
            </div>
          </form>
        </div>
      }

    </div>
  </div>

</div>



